import { FormattedMessage } from 'react-intl';

import { AssetType } from '@/shared/api/protocol-ts/model/dto_asset_pb';

type CreateReportToggleTextProps = {
  studyAssetType: AssetType;
  coins?: number;
};

export const CreateReportToggleText = (props: CreateReportToggleTextProps) => {
  const { studyAssetType, coins } = props;

  if (coins !== undefined) {
    return (
      <FormattedMessage
        id="CreateReportToggleText.withCoins"
        defaultMessage="Create AI report after uploading for {coins, plural, one {# coin} other {# coins}}"
        values={{ coins }}
      />
    );
  }

  switch (studyAssetType) {
    case AssetType.AssetType_Study_IntraoralXRay:
      return (
        <FormattedMessage
          id="CreateReportToggleText.ioxray"
          defaultMessage="Create IOXray AI report after uploading"
        />
      );

    case AssetType.AssetType_Study_PanoramicXRay:
      return (
        <FormattedMessage
          id="CreateReportToggleText.pano"
          defaultMessage="Create Pano AI report after uploading"
        />
      );

    case AssetType.AssetType_Study_CBCT:
      return (
        <FormattedMessage
          id="CreateReportToggleText.cbct"
          defaultMessage="Create AI CBCT report after loading"
        />
      );

    default:
      return null;
  }
};
